import Splide from '@splidejs/splide';

export default {
  init() {
    // JavaScript to be fired on all pages

    $('.wp-block-cover__inner-container').wrap('<div class="container"><div class="row justify-content-end"><div class="col-md-12 col-lg-6 col-xl-6"></div></div></div>');

    if ($('.product-slider').length > 0) {
      const prodictSliderInstance = document.getElementsByClassName('product-slides');
      Object.keys(prodictSliderInstance).forEach(key => {

        let arrows = (prodictSliderInstance[key].getAttribute('data-perpage') > 4 ? true : false);

        new Splide(
          prodictSliderInstance[key],
          {
            type: 'loop',
            arrows: arrows,
            pagination: false,
            gap: '15px',
            perMove: 1,
            perPage: 4,
            autoplay: true,
            breakpoints: {
              1410: {
                perPage: 4,
              },
              1199: {
                perPage: 3,
              },
              992: {
                perPage: 2,
              },
              767: {
                perPage: 1,
              },
            },
          }).mount();
      });
    }

    if ($('.partner-slider').length > 0) {
      const partnerSliderInstance = document.getElementsByClassName('partner-slider');
      const numbOfSlides = partnerSliderInstance[0].getAttribute('data-perpage');

      Object.keys(partnerSliderInstance).forEach(key => {

        let arrows = (partnerSliderInstance[key].getAttribute('data-perpage') > 4 ? true : false);

        new Splide(
          partnerSliderInstance[key],
          {
            type: 'loop',
            arrows: arrows,
            pagination: false,
            gap: '15px',
            perMove: 1,
            perPage: numbOfSlides,
            autoplay: true,
            breakpoints: {
              1410: {
                perPage: numbOfSlides,
              },
              1199: {
                perPage: numbOfSlides,
              },
              992: {
                perPage: 2,
              },
              767: {
                perPage: 1,
              },
            },
          }).mount();
      });
    }

    $('.cart-toggle').click(function (e) {
      e.preventDefault();
      $('nav.shop .mini-cart').slideToggle();
    });

    $('.woocommerce-mini-cart-item a.remove').click(function () {
      $(this).parent().remove();
    });

    $('.nav-primary .sub-menu').hide();

    $('.nav-primary .menu-item-has-children').on({
      mouseenter() {
        $(this).children('.sub-menu').stop(true, true).slideDown();
      },

      mouseleave() {
        $(this).children('.sub-menu').stop(true, true).slideUp();
      },
    });

    // Toggle navigation menu
    $(document).on('click', '.hamburger', function () {
      $(this).toggleClass('is-active');
      if ($(this).hasClass('hamburger--3dy')) {
        $('.slide-nav').toggleClass('open');
        $('.page-wrap').toggleClass('open');
        $('body').toggleClass('lock');
      } else {
        $(this)
          .prev('.sub-menu')
          .slideToggle();
      }
    });

    // Append a toggle button to navigaiton items with children
    $('.slide-nav .menu-item-has-children').each(function () {
      $(this).append('<button class="hamburger" aria-label="Toggle Menu"><i class="fa-solid fa-chevron-down"></i></button>');
    });

    // Wishlist
    if ($('nav.shop .wishlist .badge').length === 0) {

      if (localStorage.hasOwnProperty('purequestrian-wishlist')) {
        const count = sessionStorage.getItem('purequestrian-wishlist').replace(/^,|,$/g, '').split(',').length;
        if (count > 0) {
          $('nav.shop .wishlist').prepend(`
          <span class="badge badge-danger">
            ${count}
          </span>
          `);
        }
      }
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    // Create a condition that targets viewports at least 768px wide 
    const mediaQuery = window.matchMedia('(min-width: 991px)');
    const filterDropwdown = document.querySelector('#FilterCollapse');

    function handleTabletChange(e) { 
      // Check if the media query is true 
      if (e.matches) { 
        // Then log the following message to the console 
        $(filterDropwdown).addClass('show');
      } else {
        $(filterDropwdown).removeClass('show');
      }
    }

    // Register event listener
    mediaQuery.addListener(handleTabletChange);

    // Initial check 
    handleTabletChange(mediaQuery);


    // Store Notice Padding check
    const originalPaddingTop =
      parseFloat(getComputedStyle(document.body).paddingTop) || 0;

    function updateStoreNotice() {
      const notice = document.querySelector('.woocommerce-store-notice');
      const banner = document.querySelector('.banner');

      const noticeHeight = notice ? notice.offsetHeight : 0;
      const bannerHeight = banner ? banner.offsetHeight : 0;

      document.body.style.paddingTop =
        `${originalPaddingTop + noticeHeight + bannerHeight}px`;

      if (notice) {
        notice.style.top = `-${noticeHeight}px`;
      }
    }

    updateStoreNotice();

    const resizeObserver = new ResizeObserver(updateStoreNotice);

    const notice = document.querySelector('.woocommerce-store-notice');

    if (notice) {
      resizeObserver.observe(notice);
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js